<script>
	const Vue = require('vue');
	const Q = require('q');
	const model = require('model/model');
	const page = require('page');

	const analyticsUtilities = require('utilities/analyticsUtilities');
	const fireEvent = analyticsUtilities.fireEvent;
	const ONBOARDING = analyticsUtilities.events.ONBOARDING;

	const googleClassroomUtilities = require('utilities/googleClassroomUtilities');
	const authenticateWithGoogleClassroom = googleClassroomUtilities.authenticateWithGoogleClassroom;

	const {
		startJourney,
		JOURNEYS: { CLASS_ADMIN_ONBOARDING }
	} = require('utilities/journeyUtilities');

	const metadata = require('core/metadata');

	const { assetUrl } = require('utilities/urlUtilities');

	module.exports = {
		components: {
			'validated-input': require('components/validated-input.vue').default,
			'validated-form': require('components/validated-form.vue').default,
			'input-item-with-label': require('components/input-item-with-label.vue').default,
			'google-classroom-import-form': require('components/google-classroom-import-form.vue').default
		},
		modelData: ['userContext', 'account', 'localGCAccessToken', 'gcAddon'],
		data() {
			let grades = metadata.gradeSelections;
			return {
				name: '',
				grades,
				selectedGrade: '',
				waitingOnGoogleAuth: false,
				importType: ''
			};
		},
		mounted() {
			model.change('localGCAccessToken', () => {
				let waitingOnGoogleAuth = this.waitingOnGoogleAuth;
				this.waitingOnGoogleAuth = false;

				if (waitingOnGoogleAuth) {
					this.importType = 'google';
				}
			});

			if (this.gcAddon) {
				this.importType = 'google';
			}

			Vue.nextTick(() => {
				if (this.$refs && this.$refs.googleForm) {
					this.$refs.googleForm.loadClasses();
				}
			});
		},
		computed: {
			backText() {
				let account = this.account;
				let nodes = metadata.allNodesById;
				let text = 'Back to School Information';
				if (account && nodes && account.role) {
					text = nodes['_' + account.role].name;
					if (account.k12 && account.schoolName) {
						text += ' at ' + account.schoolName;
					} else if (!account.k12 && (account.city || account.state)) {
						text += ' in ';
						if (account.city) {
							text += account.city;
							if (account.state) {
								text += ', ' + account.state;
							}
						} else if (account.state) {
							text += account.state;
						}
					}
				}
				return text;
			},
			gcImageSrc() {
				return assetUrl('/assets/dist/images/google-classroom/gc_square_color_282.png');
			}
		},
		methods: {
			eventClick(action_type) {
				let data = {
					step: 'class-name',
					action_type
				};
				fireEvent(ONBOARDING, data);
			},
			importGoogleClass() {
				let localGCAccessToken = model.get('localGCAccessToken');
				if (!localGCAccessToken) {
					authenticateWithGoogleClassroom();
					this.waitingOnGoogleAuth = true;
				} else {
					this.importType = 'google';
				}
				this.beginClassJourney();
			},
			storeData() {
				let name = this.name;
				let grade = this.selectedGrade;
				let classData = { name, grade };

				if (name && grade) {
					model.set('onboardingClassData', classData);
					page('/onboarding-add-students');
				}
				return Q();
			},
			clearImport() {
				this.importType = '';
			},
			afterGoogleImport(clazz) {
				model.remove('onboardingClassData');

				if (this.gcAddon) {
					page('/find-content');
				} else {
					const { cc } = clazz;
					model.set('classType', 'google');
					model.set('className', this.name);
					model.set('classCode', cc);
					model.set('showGCImportDialog', clazz);
					page(`/class-admin#!classAdmin:roster/classCode:${cc}`);
				}
			},
			createRosterClass() {
				this.importType = 'roster';
				this.beginClassJourney();
			},
			beginClassJourney() {
				startJourney(CLASS_ADMIN_ONBOARDING);
			}
		},
		watch: {
			importType(value) {
				Vue.nextTick(() => {
					if (value === 'google' && this.$refs && this.$refs.googleForm) {
						this.$refs.googleForm.loadClasses();
					}
				});
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/variables';
	@import 'config/colors';

	.onboarding-class-name {
		.class-name-content {
			.import-type-selection {
				margin: 3rem 0;
				display: flex;
				justify-content: center;

				button {
					margin: 1rem;
					width: 17.5rem;
					height: 8rem;
					background-color: white;
					border-color: #c4c4c4;
					color: black;

					&:hover {
						border: 1px solid $c-blue;
						box-sizing: border-box;
						box-shadow: 0px 0px 10px 1px rgba(5, 159, 197, 0.43);
						border-radius: 4px;
					}

					.plus-sign {
						color: $c-blue-dark;
						font-size: 50px;
						margin-top: 0px;
						margin-bottom: 20px;
						font-weight: 1000;
					}

					.google-icon {
						width: 40px;
						margin-bottom: 10px;
						margin-top: 0px;
					}

					> p {
						margin-top: 0px;
						margin-bottom: 20px;
					}
				}
			}

			.class-name-form-body {
				display: flex;
				flex-wrap: wrap;

				.info-wrapper {
					flex: 1;

					.input-wrapper {
						max-width: 20rem;

						.class-name {
							margin-top: 1rem;
						}
					}

					.grade {
						width: 10rem;
						margin: 1rem 0;

						select {
							margin-top: 0;
						}
					}
				}
			}

			&.google {
				display: flex;
				justify-content: center;
			}
		}
	}
</style>
<template>
	<main
		id="content"
		class="main onboarding-class-name onboarding">
		<header class="onboarding-header">
			<div class="wrapper">
				<a
					href="/onboarding-role"
					class="back-nav"
					@click="eventClick('back')">
					<i
						class="fa-solid fa-chevron-left"
						aria-hidden="true"></i>
					{{ backText }}
				</a>
				<div class="account-name">{{ userContext.email }}</div>
			</div>
		</header>
		<div class="main-content wrapper">
			<section>
				<h2 class="panel-title">Let's create your first class.</h2>
				<p>
					A class allows your students to complete assignments online. If you only want to print or project assignments,
					<a href="/find-content">find content now</a>.
				</p>
				<p class="text-bold">
					Did you know if you start assigning or printing on ReadWorks within 2 weeks of signing up, you are more likely to continue to use our resources
					and see improved reading comprehension with your students?
				</p>
				<div
					class="class-name-content"
					:class="{
						google: importType === 'google'
					}">
					<div
						class="import-type-selection"
						v-if="!importType">
						<button
							type="button"
							class="button import-button"
							@click="createRosterClass">
							<p class="plus-sign">+</p>
							<p>Create a New Class</p>
						</button>
						<button
							type="button"
							class="button import-button"
							v-tooltip="'Google Classroom'"
							@click="importGoogleClass">
							<img
								class="google-icon"
								:src="gcImageSrc"
								alt="" />
							<p>Import from Google Classroom</p>
						</button>
					</div>
					<validated-form
						class="class-name-form"
						:on-submit="storeData"
						v-if="importType === 'roster'">
						<div class="class-name-form-body">
							<div class="info-wrapper">
								<div class="input-wrapper">
									<validated-input
										class="class-name"
										type="text"
										:debounce-delay="50"
										required
										v-model="name"
										name="class-name"
										unsafe></validated-input>
									<label
										for=""
										placeholder="My class will be called"
										alt="My class will be called"></label>
								</div>
								<div class="input-wrapper select-wrapper grade">
									<select
										v-model="selectedGrade"
										v-touched-field
										class="grade-input"
										required>
										<option
											disabled
											value=""></option>
										<option
											v-for="grade in grades"
											:key="grade.id"
											:value="grade.id">
											{{ grade.text }}
										</option>
									</select>
									<label
										placeholder="and is grade"
										alt="and is grade"></label>
								</div>
							</div>
						</div>
						<div class="input-wrapper submit-wrapper">
							<button
								type="submit"
								class="button submit"
								:disabled="!(name && selectedGrade)">
								Add Students
							</button>
						</div>
					</validated-form>
					<div
						v-if="importType === 'google'"
						class="roster-panel google-roster-panel">
						<div class="roster-panel-title">Google Classroom Import</div>
						<div class="roster-panel-body">
							<google-classroom-import-form
								ref="googleForm"
								:on-cancel-click="clearImport"
								:after-import="afterGoogleImport">
							</google-classroom-import-form>
						</div>
					</div>
				</div>
			</section>
		</div>
	</main>
</template>
